import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Vision from './components/Vision';
import News from './components/News';
import Company from './components/Company';
import Service from './components/Service';
import Contact from './components/Contact';
import RecruitBanner from './components/RecruitBanner';
import Footer from './components/Footer';
import SEOJsonLd from '../../components/base/SEOJsonLd';

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://example.com';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'TransportCompany'],
  '@id': `${siteUrl}/#organization`,
  name: '宝珠運輸',
  alternateName: 'HOUJYU UNYU',
  url: siteUrl,
  email: 'info@houjyu-logistics.jp',
  description:
    '宝珠運輸は名古屋を拠点に愛知・岐阜・三重の東海エリアをカバーする運送会社です。4t、2t、1tトラックはもちろん、軽バンの保有台数も多く、地域に密着した物流事業を展開しています。今できることを、大切に。',
  address: {
    '@type': 'PostalAddress',
    postalCode: '497-0006',
    streetAddress: '七宝町下之森八ノ坪3',
    addressLocality: 'あま市',
    addressRegion: '愛知県',
    addressCountry: 'JP',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '35.1978',
    longitude: '136.7648',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'info@houjyu-logistics.jp',
    contactType: 'customer service',
    availableLanguage: 'Japanese',
    hoursAvailable: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '17:00',
    },
  },
  areaServed: ['愛知県', '岐阜県', '三重県'],
  serviceType: ['運送サービス', '物流', 'トラック輸送', '倉庫事業'],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '17:00',
    },
  ],
  sameAs: [],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${siteUrl}/#website`,
  url: siteUrl,
  name: '物流なら宝珠運輸',
  description:
    '名古屋を拠点に東海エリア（愛知・岐阜・三重）をカバーする運送会社・宝珠運輸の公式サイト。',
  publisher: {
    '@id': `${siteUrl}/#organization`,
  },
  inLanguage: 'ja-JP',
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${siteUrl}/`,
  url: `${siteUrl}/`,
  name: 'Top | 物流なら宝珠運輸',
  description:
    '宝珠運輸は名古屋を拠点に愛知・岐阜・三重の東海エリアをカバーする運送会社です。4t、2t、1tトラックはもちろん、軽バンの保有台数も多く、地域に密着した物流事業を展開しています。',
  isPartOf: { '@id': `${siteUrl}/#website` },
  about: { '@id': `${siteUrl}/#organization` },
  inLanguage: 'ja-JP',
  dateModified: '2026-03-26',
};

export default function Home() {
  return (
    <div
      className="min-h-screen bg-white"
      style={{ fontFamily: `'Noto Sans JP', sans-serif` }}
    >
      <SEOJsonLd data={organizationSchema} id="jsonld-organization" />
      <SEOJsonLd data={websiteSchema} id="jsonld-website" />
      <SEOJsonLd data={webPageSchema} id="jsonld-webpage" />
      <Header />
      <main>
        <Hero />
        <Vision />
        <News />
        <Service />
        <Contact />
        <Company />
      </main>
      <RecruitBanner />
      <Footer />
    </div>
  );
}
